import React, { useEffect } from "react";
import {
  Grid,
  Typography,
  Card,
  CardContent,
  Paper,
  Button,
  ButtonBase,
} from "@mui/material";
import CustomTextField from "../../../../components/FormFields/TextField/TextField.component";
import Autocomplete from "../../../../components/FormFields/AutoCompleteText/CustomAutoComplete";
import CardType from "./CardType";
import DomainSharpIcon from "@mui/icons-material/DomainSharp";
import styles from "./Style.module.css";
import data from "./data";
import ShadowBox from "../../../../components/ShadowBox/ShadowBox";
import SidePanelComponent from "../../../../components/SidePanel/SidePanel.component";
import { useTheme } from "@mui/styles";
import { CustomOptionRadiosWithIcon } from "../../../../components/BasicAndCustomRadio/CustomOptionRadiosWithIcon";
import CustomSelectField from "../../../../components/FormFields/SelectField/SelectField.component";
import { MenuItem } from "@mui/material";
import CustomCheckbox from "../../../../components/FormFields/CustomCheckbox";
import { OutlineButton } from "../../../../components/Buttons/PrimaryButton";
import { useState, useCallback } from "react";


const TopRow = ({dashboardData}) => {
  // const classes = useStyles();
  const theme = useTheme();
  const [isSidePanel, setSidePanel] = useState(false);
  const [isAddQueryOpen, setAddQueryOpen] = useState(false);
  const handleSideToggle = useCallback(() => {
    setSidePanel((e) => !e);
  }, [setSidePanel]);
  const handleAddQueryToggle = useCallback(() => {
    setAddQueryOpen((e) => !e);
  }, [setAddQueryOpen]);
  // const { Data } = data;

  return (
    <>
      <div className={styles.innerContainer}>
        {data.Data.map((item, index) => (
          <>
            <div className={`${styles.wrapper} `}>
              <ShadowBox>
                <Typography
                  variant={"h5"}
                  color={"text.primary"}
                  sx={{ mb: 1.5 }}
                >
                  Overview
                </Typography>

                <div className={styles.dFlex}>
                  {/* <div className={styles.iconCont}>
                    <img
                      src={item.image1}
                      className={styles.iconImg}
                      alt="Clients"
                    />
                    <div className={styles.dataContain}>
                      <Typography variant={"h3"} color={"text.primary"}>
                        {dashboardData?.clients}
                      </Typography>

                      <Typography variant={"body2"} color={"text.secondary"}>
                        {item.clientSubtitle}
                      </Typography>
                    </div>
                  </div> */}

                  <div className={styles.iconCont}>
                    <img
                      src={item.image2}
                      className={styles.iconImg}
                      alt="Programs"
                    />
                    <div className={styles.dataContain}>
                      <Typography variant={"h3"} color={"text.primary"}>
                      {dashboardData?.programs}
                      </Typography>

                      <Typography variant={"body2"} color={"text.secondary"}>
                        {item.programsSubtitle}{" "}
                      </Typography>
                    </div>
                  </div>
                  <div className={styles.iconCont}>
                    <img
                      src={item.image4}
                      className={styles.iconImg}
                      alt="Total"
                    />
                    <div className={styles.dataContain}>
                      <Typography variant={"h3"} color={"text.primary"}>
                      {dashboardData?.app_users}
                      </Typography>

                      <Typography variant={"body2"} color={"text.secondary"}>
                        {item.totalAppUsersSubtitle}
                      </Typography>
                    </div>
                  </div>
                  <div className={styles.iconCont}>
                    <img
                      src={item.image5}
                      className={styles.iconImg}
                      alt="new signup"
                    />
                    <div className={styles.dataContain}>
                      <Typography variant={"h3"} color={"text.primary"}>
                      {dashboardData?.app_users_new}
                      </Typography>

                      <Typography variant={"body2"} color={"text.secondary"}>
                        {item?.totalSignupSubtitle}{" "}
                      </Typography>
                    </div>
                  </div>

                  {/* <div className={styles.iconCont}>
                    <img
                      src={item.image3}
                      className={styles.iconImg}
                      alt="Doctors"
                    />
                    <div className={styles.dataContain}>
                      <Typography variant={"h3"} color={"text.primary"}>
                      {dashboardData?.doctors}
                      </Typography>

                      <Typography variant={"body2"} color={"text.secondary"}>
                        {item.doctorSubtitle}{" "}
                      </Typography>
                    </div>
                  </div> */}
                </div>
              </ShadowBox>
            </div>

            {/* <div className={`${styles.wrapper2} `}>
              <ShadowBox>
                <Typography
                  variant={"h5"}
                  color={"text.primary"}
                  sx={{ mb: 1.5 }}
                >
                  {item.totalAppUsersHeading}
                </Typography>

                <div className={styles.dFlex}>
                  <div className={styles.iconCont}>
                    <img
                      src={item.image4}
                      className={styles.iconImg}
                      alt="Total"
                    />
                    <div className={styles.dataContain}>
                      <Typography variant={"h3"} color={"text.primary"}>
                      {dashboardData?.app_users}
                      </Typography>

                      <Typography variant={"body2"} color={"text.secondary"}>
                        {item.totalAppUsersSubtitle}
                      </Typography>
                    </div>
                  </div>


                  <div className={styles.iconCont}>
                    <img
                      src={item.image5}
                      className={styles.iconImg}
                      alt="new signup"
                    />
                    <div className={styles.dataContain}>
                      <Typography variant={"h3"} color={"text.primary"}>
                      {dashboardData?.app_users_new}
                      </Typography>

                      <Typography variant={"body2"} color={"text.secondary"}>
                        {item?.totalSignupSubtitle}{" "}
                      </Typography>
                    </div>
                  </div>
                </div>
              </ShadowBox>
            </div> */}


          </>
        ))}
      </div>

    </>
  );
};

export default TopRow;
